document.addEventListener('DOMContentLoaded', function(event) {

  const hc_button = document.querySelector('.hc-search');
  
  hc_button.addEventListener('keyup', function() {
    
    var predictive_search_container = document.querySelector('.hc-predictive-container');
    var search_input = this.parentElement.querySelector('input');
    var search_value = search_input.value;
    var hc_blog_url = search_input.getAttribute('data-url');
    var limit = 50;

    if(search_value != ''){
      console.log('VALUE!');
      fetch(`/search/suggest.json?q=${search_value}&resources[type]=article&resources[limit]=${limit}`)
        .then(response => response.json())
        .then(data => {
            var hcSuggestions = data.resources.results.articles;
  
            predictive_search_container.innerHTML = '';
  
            var html = '';
  
            if (hcSuggestions.length > 0) {
              hcSuggestions.forEach(function(hcSuggestion, index) {
                html += '<div class="hc-result">';
                html += '<a href="'+ hcSuggestion.url +'">';
                html += '<div class="predictive_image"><img src="' + hcSuggestion.image + '"/>';
                html += '</div><div class="hc-predictive-title">' + hcSuggestion.title + '</div>';
                html += '</a>';
                html += '</div>';
                predictive_search_container.innerHTML += html;
                html = '';
              });
            }
        });
        predictive_search_container.style.display = 'grid';
      }else{
        console.log('NO VALUE!');
        predictive_search_container.style.display = 'none';
      }
  });
});

// document.addEventListener('DOMContentLoaded', function() {
//   // Select all color swatch items
//   const colorSwatches = document.querySelectorAll('.color-swatch-item');

//   colorSwatches.forEach(swatch => {
//     swatch.addEventListener('click', function(event) {
//       // Prevent default behavior (e.g., following the link)
//       event.preventDefault();

//       // Get the new product ID, title, and URL from the clicked swatch
//       const newProductId = this.getAttribute('data-product-id');
//       const newProductHandle = this.getAttribute('data-product-handle');
//       const newProductTitle = this.getAttribute('data-product-title');
//       const newProductUrl = this.getAttribute('data-href');
//       const newPrimaryImageUrl = this.getAttribute('data-primary-image-src');  // New primary image
//       const newSecondaryImageUrl = this.getAttribute('data-secondary-image-src');  // New secondary image (hover image)

//       // Find the closest product grid item (to scope the updates)
//       const productGridItem = this.closest('.grid__item');

//       if (productGridItem) {
//         // Remove active class from all swatches within this grid item
//         const allSwatches = productGridItem.querySelectorAll('.color-swatch-item');
//         allSwatches.forEach(swatch => {
//           swatch.classList.remove('active');
//         });

//         // Add active class to the clicked swatch
//         this.classList.add('active');

//         // Update the quick view button's data-product-id within this grid item
//         const quickViewButton = productGridItem.querySelector('.quick-product__btn');
//         if (quickViewButton) {
//           // Clone the quick view button to remove event listeners
//           const newQuickViewButton = quickViewButton.cloneNode(true);
          
//           // Replace the old button with the cloned one
//           quickViewButton.replaceWith(newQuickViewButton);

//           // Remove old dynamic class
//           quickViewButton.classList.forEach(cls => {
//             if (cls.startsWith('js-modal-open-quick-modal-')) {
//               quickViewButton.classList.remove(cls);
//             }
//           });

//           // Add new dynamic class with the current product ID
//           quickViewButton.classList.add(`js-modal-open-quick-modal-${newProductId}`);
//         }

//         // Update the data-product-handle and data-product-id of the product grid item itself
//         productGridItem.setAttribute('data-product-handle', newProductHandle);
//         productGridItem.setAttribute('data-product-id', newProductId);

//         theme.initQuickShop();

//         // Update the product title within this grid item
//         const productTitleElement = productGridItem.querySelector('.grid-product__title');
//         if (productTitleElement) {
//           productTitleElement.textContent = newProductTitle;
//         }

//         // Update the anchor tag's href attribute within this grid item
//         const productLink = productGridItem.querySelector('.grid-product__link');
//         if (productLink) {
//           productLink.setAttribute('href', newProductUrl);
//         }

//         // Update the primary product image
//         // const productImage = productGridItem.querySelector('.grid-product__image');
//         // if (productImage) {
//         //   productImage.removeAttribute('srcset');
//         //   productImage.setAttribute('src', newPrimaryImageUrl);
//         //   productImage.setAttribute('data-src', newPrimaryImageUrl); // For lazy loading, if applicable
//         // }

//         // // Update the secondary (hover) image if it exists
//         // const secondaryImage = productGridItem.querySelector('.grid-product__secondary-image img');
//         // if (secondaryImage) {
//         //   secondaryImage.removeAttribute('srcset');
//         //   secondaryImage.setAttribute('src', newSecondaryImageUrl);
//         //   secondaryImage.setAttribute('data-src', newSecondaryImageUrl); // For lazy loading
//         // }
//       }
//     });
//   });
// });

// function showColorImage(productId, variantId) {
//   // Hide all color variant images
//   const allVariantImages = document.querySelectorAll(`.color-image-${productId}`);
//   allVariantImages.forEach(image => {
//     image.classList.add('hide-color-images');
//   });

//   // Show the selected variant's images
//   const selectedImages = document.querySelectorAll(`.color-image-${productId}-${variantId}`);
//   selectedImages.forEach(image => {
//     image.classList.remove('hide-color-images');
//   });
// }

// function toggleSwatches(productId, element) {
//   const colorContainer = element.closest('.color-container');

//   // Get all hidden swatches for this specific product
//   const hiddenSwatches = colorContainer.querySelectorAll('.hidden-swatch-' + productId);

//   // Check if we are expanding or collapsing
//   const moreButton = colorContainer.querySelector('.view-more-swatches-' + productId);
//   const lessButton = colorContainer.querySelector('.view-less-swatches-' + productId);

//   if (moreButton.style.display !== 'none') {
//     // Show all hidden swatches for this product
//     hiddenSwatches.forEach(swatch => {
//       swatch.style.display = 'inline-block';
//     });

//     // Hide "More" button and show "Less" button
//     moreButton.style.display = 'none';
//     lessButton.style.display = 'inline';

//   } else {
//     // Hide all hidden swatches for this product
//     hiddenSwatches.forEach(swatch => {
//       swatch.style.display = 'none';
//     });

//     // Show "More" button and hide "Less" button
//     moreButton.style.display = 'inline';
//     lessButton.style.display = 'none';
//   }
// }
